import { httpRequest } from 'http'

export const GREETING_LANDING_INFO = 'GREETING_LANDING_INFO'

export function requestGreetingLandingInfo() {
    return async (dispatch) => {
        const response = await httpRequest('/game_api/account_info')

        dispatch({
            type: GREETING_LANDING_INFO,
            payload: response.clan,
        })
    }
}



// WEBPACK FOOTER //
// ./state/actions/greeting_landing.js